import { type Enum } from '@webapp/infrastructure/types/Enum'

export const IssuingProviders = {
  AIRWALLEX: 1,
} as const
export type IssuingProviderEnum = Enum<typeof IssuingProviders>
